import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import SnelleBouwRenovatie from "./sections/SnelleBouwRenovatie";
import TrustInCollaboration from "./sections/TrustInCollaboration";
import WhyChooseUs from "./sections/WhyChooseUs";
import WatOnzeKlantenZeggen from "./sections/WatOnzeKlantenZeggen";
import ReadyToFeast from "./sections/ReadyToFeast";
import OurImpact from "./sections/OurImpact";
import TechnischAdviesNodig from "./sections/TechnischAdviesNodig";
import FooterInformation from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <SnelleBouwRenovatie />
      <TrustInCollaboration />
      <WhyChooseUs />
      <WatOnzeKlantenZeggen />
      <ReadyToFeast />
      <OurImpact />
      <TechnischAdviesNodig />
      <FooterInformation />
    </div>;
}